import React from 'react';
import './style.scss';

export type CheckBoxItemType = {
  label: string;
  checked: boolean;
};
type CheckBoxGloupProps = {
  items: CheckBoxItemType[];
  setItems?: React.Dispatch<React.SetStateAction<CheckBoxItemType[]>>;
  cb?: (items: CheckBoxItemType[]) => void;
  exclusiveItem?: string;
};

export const CheckBoxGloup = ({ items, setItems, cb, exclusiveItem }: CheckBoxGloupProps) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newItems = items.map((item) => {
      const newItem = { ...item };
      if (newItem.label === e.target.value) {
        newItem.checked = !newItem.checked;
      }
      return newItem;
    });

    if (exclusiveItem) {
      const exclusiveOn = e.target.value === exclusiveItem && newItems.find((x) => x.label === exclusiveItem)?.checked;
      newItems
        .filter((item) => (exclusiveOn ? item.label !== exclusiveItem : item.label === exclusiveItem))
        .forEach((item) => {
          item.checked = false;
        });
    }
    setItems && setItems(newItems);
    cb && cb(newItems);
  };

  return (
    <div className="choicesWrapper">
      {items?.map((item) => {
        return (
          <div className="establishChoices" key={item.label}>
            <input id={item.label} type="checkbox" value={item.label} checked={item.checked} onChange={onChange} />
            <label htmlFor={item.label}>{item.label}</label>
          </div>
        );
      })}
    </div>
  );
};
